import { createSlice } from "@reduxjs/toolkit";
import { ITopupRequestState } from "./topupModel";
import {
  deleteTopupRequest,
  getAllActiveBankAccounts,
  getAllActiveBanks,
  getAllTopupRequests,
  getTopupRequestByID,
  insertTopupRequest,
  updateTopupRequest,
} from "./services/topup.services";

const initialState: ITopupRequestState = {
  loading: false,
  formLoading: false,
  error: "",
  TopupRequestList: [],
  BankList: [],
  BankAccountList: [],
  TopupRequestID: null,
  TopupRequestDetail: {
    AccHoloderName: "",
    AccountNo: "",
    Amount: null,
    BankID: null,
    ChequeBranchName: "",
    ChequeNo: "",
    CustomerID: null,
    DepositedBankID: null,
    DepositedBranch: "",
    DepositedMode: "",
    EmployeeID: null,
    NetTransferID: "",
    Remarks: "",
    TransactionDate: "",
    TransactionNo: "",
    Type: "Cheque",
  },
};

const topupSlice = createSlice({
  name: "topup",
  initialState,
  reducers: {
    setTopupRequestID: (state, action) => {
      state.TopupRequestID = action.payload;
    },
    clearTopupRequestID: (state) => {
      state.TopupRequestID = initialState.TopupRequestID;
    },
    clearTopupRequestDetails: (state) => {
      state.TopupRequestDetail = initialState.TopupRequestDetail;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllTopupRequests.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getAllTopupRequests.fulfilled, (state, action) => {
      state.loading = false;
      state.TopupRequestList = action.payload;
    });
    builder.addCase(getAllTopupRequests.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.TopupRequestList = initialState.TopupRequestList;
    });
    builder.addCase(insertTopupRequest.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(insertTopupRequest.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(insertTopupRequest.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateTopupRequest.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateTopupRequest.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(updateTopupRequest.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteTopupRequest.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteTopupRequest.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteTopupRequest.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getTopupRequestByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getTopupRequestByID.fulfilled, (state, action) => {
      state.loading = false;
      state.TopupRequestDetail = action.payload;
    });
    builder.addCase(getTopupRequestByID.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.TopupRequestDetail = initialState.TopupRequestDetail;
    });
    builder.addCase(getAllActiveBanks.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getAllActiveBanks.fulfilled, (state, action) => {
      state.loading = false;
      state.BankList = action.payload;
    });
    builder.addCase(getAllActiveBanks.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BankList = initialState.BankList;
    });
    builder.addCase(getAllActiveBankAccounts.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getAllActiveBankAccounts.fulfilled, (state, action) => {
      state.loading = false;
      state.BankAccountList = action.payload;
    });
    builder.addCase(getAllActiveBankAccounts.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.BankAccountList = initialState.BankAccountList;
    });
  },
});

export const {
  clearTopupRequestDetails,
  clearTopupRequestID,
  setTopupRequestID,
} = topupSlice.actions;

export default topupSlice.reducer;
